import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { string, shape, bool, arrayOf, func } from "prop-types";

import Transcript from "./VideoTranscript";
import { find, timeInSeconds } from "../../../utilities";
import VideoDialog from "../../../Pages/Reports/SentimentReport/VideoDialog";
import { operations as videoDetailOperations } from "../../../Shared/modules/videoDetail";
import { operations as videoProductsOperations } from "../../../Shared/modules/videoProducts";

const TranscriptIndex = ({
  videos,
  search,
  notes,
  transcript,
  totalVideo,
  toggleTranscript,
  keywordsOnly,
}) => {
  const [openVideoDetail, setOpenVideoDetail] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const dispatch = useDispatch();

  const videoDetail = useSelector((state) => state.videoDetail);
  const videoProducts = useSelector((state) => state.videoProducts);

  const handleCloseVideoDetail = () => setOpenVideoDetail(false);

  const handlePlayVideoSentence = (videoId, timeStamp) => () => {
    dispatch(videoDetailOperations.fetchVideoDetail(videoId));
    dispatch(videoProductsOperations.fetchVideoProducts(videoId));
    if (!!timeStamp || timeStamp === 0) {
      setStartTime(timeInSeconds(timeStamp));
    }
    setOpenVideoDetail(true);
  };

  return (
    <div id="TranscriptsContainer" style={{ paddingBottom: "312px" }}>
      <>
        {videos.map(({ video }) => (
          <Transcript
            totalVideo={totalVideo}
            transcript={transcript.find((x) => x.video_id === video._id) || {}}
            key={video._id}
            video={video}
            note={find(notes, video._id, "video_id")}
            search={search}
            handlePlayVideoSentence={handlePlayVideoSentence}
            toggleTranscript={toggleTranscript}
            keywordsSwitch={keywordsOnly}
          />
        ))}
        <VideoDialog
          open={openVideoDetail}
          handleClose={handleCloseVideoDetail}
          videoDetail={videoDetail}
          videoProducts={videoProducts}
          start={startTime}
        />
      </>
    </div>
  );
};

TranscriptIndex.defaultProps = {
  videos: [],
  notes: [],
  videoProducts: {},
  transcript: [],
};

TranscriptIndex.propTypes = {
  videos: arrayOf(shape({})),
  transcript: arrayOf(shape({})),
  search: string.isRequired,
  loading: bool.isRequired,
  notes: arrayOf(shape({})),
  videoProducts: shape({}),
  fetchVideoProducts: func.isRequired,
};

export default TranscriptIndex;
